module.exports = __webpack_public_path__ + "img/resized-APP-0004-2.6598637d.png";